import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
  cursor: help;
  
  &:hover .tooltip-content {
    opacity: 1;
    visibility: visible;
    transform: translateY(0) translateX(-50%);
  }
`;

const TriggerElement = styled.span`
  color: var(--accent);
  border-bottom: 1px dotted var(--accent);
  font-weight: 500;
`;

const ContentBox = styled.div`
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateY(8px) translateX(-50%);
  background: var(--glass-2);
  backdrop-filter: blur(var(--glass-blur-heavy));
  border: 1px solid var(--glass-border);
  box-shadow: 0 10px 40px rgba(0,0,0,0.3);
  padding: 10px 14px;
  border-radius: var(--radius-sm, 8px);
  color: var(--text-primary);
  font-size: 12px;
  white-space: nowrap;
  z-index: 100;
  
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
  
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: var(--glass-2) transparent transparent transparent;
  }
`;

const TooltipWidget = ({ node }) => {
  const triggerText = node.content?.triggerText || 'Hover mich';
  const tooltipText = node.content?.tooltipText || 'Das ist eine wichtige Erklärung.';

  return (
    <div style={{ textAlign: node.style?.desktop?.align || 'center' }}>
      <TooltipWrapper>
        <TriggerElement>{triggerText}</TriggerElement>
        <ContentBox className="tooltip-content">{tooltipText}</ContentBox>
      </TooltipWrapper>
    </div>
  );
};

registry.register('tooltip_text', {
  label: 'Tooltip Text',
  icon: '💬',
  category: 'advanced',
  defaultContent: {
    triggerText: '5G Netzabdeckung',
    tooltipText: 'Verfügbar in über 80% des Landes'
  },
  defaultStyle: {
    desktop: { align: 'center' }
  },
  render: TooltipWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Texte',
          fields: [
            { name: 'content.triggerText', label: 'Auslöser (Sichtbarer Text)', type: 'text' },
            { name: 'content.tooltipText', label: 'Tooltip Erklärung', type: 'textarea' }
          ]
        }
      ]
    },
    {
      tab: 'style',
      groups: [
        {
          title: 'Layout',
          fields: [
            { name: 'style.desktop.align', label: 'Ausrichtung', type: 'select', options: [{label:'Links', value:'left'}, {label:'Zentriert', value:'center'}, {label:'Rechts', value:'right'}] }
          ]
        }
      ]
    }
  ]
});
